import { useState } from "react"

import { useFormSections, useFields } from "web/hooks/data"

import { useCurrentTLO } from "web/hooks/context"

import { ContentBox, Toggle } from "web/components"

import ViewOrEdit from "./ViewOrEdit"

export default function ViewOrEditComparableDealAsset({
  excludedFieldIds = [],
}) {
  const [fieldFilter, setFieldFilter] = useState("")
  const [showAllFields, setShowAllFields] = useState({ value: false })

  const { data, userCan } = useCurrentTLO()
  const assetFields = useFields({ subjectType: "asset" })
  const comparableDealAssetFields = useFields({
    subjectType: "sale_asset",
  })

  const assetFormSections = useFormSections({ subjectType: "asset" })
  const comparableDealAssetFormSections = useFormSections({
    subjectType: "sale_asset",
  })

  const userCanUpdate = userCan("update")

  async function handleFieldChange(update) {
    const valueBlob = (x) => ({ value: x, form_value: x })

    const formattedUpdate = Object.keys(update).reduce(
      (result, key) => ({ ...result, [key]: valueBlob(update[key]) }),
      {}
    )

    const newLocalData = {
      ...data,
      values: { ...data.values, ...formattedUpdate },
    }
    data.update(update, newLocalData)
  }

  function handleLoadEmpty() {
    if (userCanUpdate) setShowAllFields({ value: true })
  }

  const editableAssetFields = assetFields.filter(
    (f) => !excludedFieldIds.includes(f.id)
  )

  const editableDealAssetFields = comparableDealAssetFields.filter(
    (f) => !excludedFieldIds.includes(f.id)
  )

  const hasComparableDealAssetFields = Object.keys(data.values).some((field) =>
    comparableDealAssetFields.map((f) => f.key).includes(field)
  )

  const hasDealAssetFieldValues =
    Object.keys(data.values).filter(
      (f) => f !== "deal_asset_origin_id" && f.match(/deal_asset/gi)
    ).length > 0

  return (
    <>
      <div className="view-or-edit-tlo-tools">
        {userCanUpdate && (
          <div className="view-or-edit-show-all-fields">
            <Toggle
              label="Show All Fields"
              checked={showAllFields.value}
              onClick={() => setShowAllFields({ value: !showAllFields.value })}
            />
          </div>
        )}
        <div className="view-or-edit-quick-filter">
          <input
            value={fieldFilter}
            placeholder="Search fields..."
            onChange={(e) => setFieldFilter(e.target.value)}
          />
        </div>
      </div>
      {((hasComparableDealAssetFields && hasDealAssetFieldValues) ||
        showAllFields.value) && (
        <ContentBox className="mb-1">
          <span className="-mt-1 mb-5 flex items-center border-b pb-2">
            <span className="text-lg font-bold">Sale-Related Details</span>
          </span>

          <ViewOrEdit
            data={data}
            fields={editableDealAssetFields}
            fieldFilter={fieldFilter}
            sections={comparableDealAssetFormSections}
            showAll={showAllFields.value}
            readOnly={!userCanUpdate}
            onFieldChanged={handleFieldChange}
            onLoadedEmpty={handleLoadEmpty}
          />
        </ContentBox>
      )}
      <ContentBox>
        <span className="-mt-1 mb-5 flex items-center border-b pb-2">
          <span className="text-lg font-bold">Asset Details</span>
        </span>
        <ViewOrEdit
          data={data}
          fields={editableAssetFields}
          fieldFilter={fieldFilter}
          sections={assetFormSections}
          showAll={showAllFields.value}
          readOnly={!userCanUpdate}
          onFieldChanged={handleFieldChange}
          onLoadedEmpty={handleLoadEmpty}
        />
      </ContentBox>
    </>
  )
}
